var map = {
	"./clinique-score.jpg": "8f80",
	"./clinique.jpg": "f99b",
	"./origins-score.jpg": "1086",
	"./origins.jpg": "06f9",
	"./test/1.jpg": "f367",
	"./test/2.jpg": "bfed",
	"./test/3.jpg": "0c8a",
	"./test/4.jpg": "99be",
	"./test/product_1.jpg": "cc53",
	"./test/product_2.jpg": "30d9",
	"./test/product_3.jpg": "8599"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";